import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

const routes = [
  {
    path: "/",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/HomeView.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "prompt",
        component: () => import("../views/home/PromptView.vue"),
      },
      {
        path: "history",
        component: () => import("../views/home/requests/HistoryView.vue"),
      },
      {
        path: "completeResults/:requestId",
        component: () =>
          import("../views/home/requests/CompleteResultsView.vue"),
      },
      {
        path: "lessons",
        component: () => import("../views/home/LessonsView.vue"),
      },
    ],
  },
  // Redirect 404 to login
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// The token is restored from the local storage before the first navigation,
// so a reload on a /home page stays there instead of going back to the login
// page, and the login page is skipped while a session is open.
router.beforeEach((to) => {
  const loggedIn = !!store.state.token;

  if (to.meta.requiresAuth && !loggedIn) return { path: "/" };
  if (to.name === "login" && loggedIn) return { path: "/home/prompt" };

  return true;
});

export default router;
